import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { I18n } from 'common/i18n';
import FilterPropType from 'common/propTypes/FilterPropType';
import { isColumnUsableWithMeasureArgument } from 'common/performance_measures/measureCalculator';
import measurePropType from 'common/performance_measures/propTypes/measurePropType';

import ColumnDropdown from '../ColumnDropdown';
import { setColumn } from '../../../actions/editor';
import { MeasureFilterBar } from '../FilterBar';

export class Sum extends Component {
  renderFilterBar() {
    const { calculationNotConfigured, calculationFilters, displayableFilterableColumns, measure } =
      this.props;

    // displayableFilterableColumns is not available until a data source has been selected _and_ its metadata
    // has loaded, but it is required to load the FilterBar.
    if (_.isEmpty(displayableFilterableColumns)) {
      return;
    }

    const filterableColumns = _.filter(displayableFilterableColumns, (column) => {
      // TODO: make valueColumn a constant
      return isColumnUsableWithMeasureArgument(column, measure, 'valueColumn');
    });

    return (
      <MeasureFilterBar
        addFilterDisabled={calculationNotConfigured || _.isEmpty(filterableColumns)}
        filters={calculationFilters}
      />
    );
  }

  // Left-hand pane with count-specific options.
  renderConfigPane() {
    const { columnFieldName, displayableFilterableColumns, measure, onSelectColumn } = this.props;

    const dropdownOptions = {
      columnFieldName,
      displayableFilterableColumns,
      id: 'sum-column',
      measure,
      measureArgument: 'valueColumn',
      onSelectColumn,
    };

    return (
      <div className="metric-config">
        <h5>{I18n.t('shared.measures_editor.measure.edit_modal.calculation.types.sum.title')}</h5>
        <div className="column-dropdown">
          <ColumnDropdown {...dropdownOptions} />
        </div>
        {this.renderFilterBar()}
      </div>
    );
  }

  renderDefinitionText() {
    return (
      <div className="metric-definition-text">
        <h5>{I18n.t('shared.measures_editor.measure.edit_modal.calculation.types.sum.help_title')}</h5>
        {I18n.t('shared.measures_editor.measure.edit_modal.calculation.types.sum.help_body')}
      </div>
    );
  }

  render() {
    return (
      <div className="metric-container">
        {this.renderConfigPane()}
        {this.renderDefinitionText()}
      </div>
    );
  }
}

Sum.defaultProps = {
  calculationNotConfigured: false,
};

Sum.propTypes = {
  calculationNotConfigured: PropTypes.bool,
  calculationFilters: PropTypes.arrayOf(FilterPropType),
  columnFieldName: PropTypes.string,
  displayableFilterableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      renderTypeName: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      fieldName: PropTypes.string.isRequired,
    }),
  ),
  measure: measurePropType.isRequired,
  onSelectColumn: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const calculationFilters = _.get(state, 'editor.measure.metricConfig.arguments.calculationFilters');
  const columnFieldName = _.get(state, 'editor.measure.metricConfig.arguments.column');
  const displayableFilterableColumns = _.get(state, 'editor.displayableFilterableColumns');

  return {
    calculationFilters,
    columnFieldName,
    displayableFilterableColumns,
    measure: state.editor.measure,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSelectColumn: setColumn,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Sum);
